module.exports = __webpack_public_path__ + "static/media/token-logo.dad83be1.png";